
export const zh = {
  auth: {
    login: "登录",
    startFreeTrial: "开始免费试用",
    register: "注册",
    email: "电子邮件",
    password: "密码",
    forgotPassword: "忘记密码？",
    alreadyHaveAccount: "已有账户？",
    dontHaveAccount: "没有账户？",
    errorDescription: "发生错误",
    errorTitle: "错误",
    successTitle: "成功",
    successDescription: "操作成功",
    continueWithGoogle: "使用 Google 继续",
    createAccount: "创建账户",
    trialDescription: "14天免费试用",
    emailPlaceholder: "your@email.com",
    creating: "创建中...",
    create: "创建",
    errorMessage: "发生错误"
  },
  navigation: {
    pricing: "定价",
    about: "关于",
    contact: "联系",
    themes: "主题",
    resources: "资源",
    home: "首页",
    dashboard: "仪表板",
    products: "产品",
    orders: "订单",
    customers: "客户",
    settings: "设置"
  },
  footer: {
    acceptedPayments: "接受的付款方式",
    allRightsReserved: "版权所有",
    quickLinks: "快速链接",
    legalNotice: "法律声明",
    accessibility: "无障碍",
    termsOfUse: "使用条款",
    support: "支持",
    followUs: "关注我们",
    socialMedia: "在社交媒体上找到我们",
    newsletter: "新闻通讯",
    subscribeNewsletter: "订阅我们的新闻通讯",
    emailPlaceholder: "你的邮箱",
    subscribe: "订阅",
    changeLanguage: "更改语言"
  },
  pricing: {
    title: "计划和定价",
    subtitle: "选择适合您的计划",
    startTrial: "开始免费试用",
    mostPopular: "最受欢迎",
    freeTrial: "14天免费试用",
    perMonth: "/月",
    basic: {
      name: "基础版",
      price: "11",
      description: "入门级",
      features: [
        "1个商店",
        "100个产品",
        "邮件支持"
      ]
    },
    pro: {
      name: "专业版",
      price: "25",
      description: "适合专业用户",
      features: [
        "3个商店",
        "1000个产品",
        "优先支持",
        "高级分析"
      ]
    },
    enterprise: {
      name: "企业版",
      price: "97",
      description: "适合大型企业",
      features: [
        "无限商店",
        "无限产品",
        "专属支持",
        "自定义API"
      ]
    }
  },
  profile: {
    title: "我的档案",
    fullName: "全名",
    phoneNumber: "电话号码",
    update: "更新",
    updating: "更新中...",
    success: "档案更新成功",
    error: "更新档案时出错"
  },
  common: {
    loading: "加载中...",
    error: "错误",
    success: "成功",
    save: "保存",
    cancel: "取消",
    delete: "删除",
    edit: "编辑",
    create: "创建",
    search: "搜索",
    filter: "筛选",
    sort: "排序",
    actions: "操作",
    confirm: "确认",
    back: "返回",
    next: "下一步",
    previous: "上一步",
    close: "关闭"
  }
};
